//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Match = require('@/tbs/model/to/Match')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Match class works as the organization translator.
 */
const tbs_model_to_MatchManager = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Match, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_MatchManager.prototype = {
    'referee-group': '裁判组',
    'staff-group': '工作组',
    'sponsor-group': '赞助商',
    'match-group': '组别',
    'rule': '规则',
    'team': '球队',
    'match-schedule': '赛程',
    'signup-payment': '报名缴费',
    'suspension-reminder': '停赛提醒',
    'registration': '智能检录',
    'draw-cuts': '线上抽签',
    'record-stats': '录数据',
    'announcement': '新闻/公告',
    'vote': '评选/投票',
    'prize': '奖项',
    'player-card': '球员卡',
    'intro-video': '宣传片',
    'match-stats': '数据统计',
    'opened': '已开',
    'closed': '关闭',
    'open-signup': '开通报名',
    'open-signup-confirm-message': '开通报名前，请先完成机构认证',
}

//--------------------------------------------------
// extends the Match
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_MatchManager, Match);

module.exports = tbs_model_to_MatchManager